module.exports = __webpack_public_path__ + "img/pass2.1611ce82.png";